interface NodeLocation {
  lat?: number | null;
  lon?: number | null;
}

interface NodeRecordLike extends NodeLocation {
  endPointId?: string | null;
}

/** The Real-Time Dashboard only lists nodes it can place on its map. */
export function hasMapLocation(record: NodeLocation | null | undefined): boolean {
  return record?.lat != null && record?.lon != null;
}

/**
 * Ids of the nodes the Real-Time Dashboard lists for an org level and parameter. Its source,
 * SensorRecord/GetLatestNodeRecords, only returns nodes with a sensor assignment that is active now and
 * carries the parameter, and the dashboard then keeps the ones it can place on the map.
 */
export function getDashboardNodeIds(records: NodeRecordLike[] | null | undefined): Set<string> {
  return new Set(
    (records ?? [])
      .filter((record) => !!record?.endPointId && hasMapLocation(record))
      .map((record) => record.endPointId as string),
  );
}
